module.exports = __webpack_public_path__ + "static/mr-press-05-e2367a6d79572af1445fb73c16db3796.jpg";